import type { ActiveCartItem, ActiveShoppingCart } from '../types';
import { toListPillarId } from './shoppingCategories';

export function findActiveCartItemForListIngredient(
    activeCart: ActiveShoppingCart | null | undefined,
    ingredient: { name: string; cartId?: string },
): ActiveCartItem | undefined {
    if (!activeCart?.items?.length) return undefined;

    const nameClean = ingredient.name.toLowerCase().trim();
    const listPillarId = ingredient.cartId ? toListPillarId(ingredient.cartId) : '';

    return activeCart.items.find(
        (item) =>
            item.name.toLowerCase().trim() === nameClean
            && (item.category || '') === listPillarId,
    );
}

export function isIngredientInActiveCart(
    activeCart: ActiveShoppingCart | null | undefined,
    ingredient: { name: string; cartId?: string },
): boolean {
    return findActiveCartItemForListIngredient(activeCart, ingredient) !== undefined;
}
